module.exports = __webpack_public_path__ + "public/img/lab.45bca7de.svg";